import { render, staticRenderFns } from "./ProfileRequirementGroup.vue?vue&type=template&id=29fbf9b8&"
import script from "./ProfileRequirementGroup.vue?vue&type=script&lang=js&"
export * from "./ProfileRequirementGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports